import { useState } from "react";
import FacilityAccordion from "@/components/feature/FacilityAccordion";

const facilities = [
  { name: "Hammond Post Office — Main Branch", address: "400 NW Railroad Ave, Hammond, LA 70401", hours: "Mon–Fri, 9:00 AM – 5:00 PM", phone: "(985) 345-4951", type: "Post Office", note: "Passport acceptance clerk. Appointment strongly recommended. Bring completed DS-11 for first-time applicants.", featured: true },
  { name: "Hammond City Hall — Clerk's Office", address: "400 W Thomas St, Hammond, LA 70401", hours: "Mon–Fri, 8:00 AM – 4:30 PM", phone: "(985) 277-5600", type: "Government Office", note: "Municipal records and acceptance services. Call ahead to confirm passport clerk availability.", featured: false },
  { name: "Ponchatoula Post Office", address: "137 W Pine St, Ponchatoula, LA 70454", hours: "Mon–Fri, 9:00 AM – 5:00 PM", phone: "(985) 386-2432", type: "Post Office", note: "Tangipahoa Parish option for Ponchatoula residents. Appointment recommended.", featured: false },
  { name: "Amite Post Office", address: "105 E Mulberry St, Amite City, LA 70422", hours: "Mon–Fri, 9:00 AM – 4:30 PM", phone: "(985) 748-5471", type: "Post Office", note: "North Tangipahoa Parish option. Call ahead for passport clerk hours.", featured: false },
];

export default function HammondAcceptanceFacilitiesSection() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  return (
    <section id="facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Hammond
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            First-time passport applicants must appear in person at an acceptance facility. If you already have a passport to renew, you can mail it in and skip the facility visit — contact us to confirm your eligibility.
          </p>
        </div>

        <div className="space-y-3 mb-8">
          {facilities.map((f, i) => (
            <FacilityAccordion
              key={i}
              facility={f}
              isExpanded={expandedIndex === i}
              onToggle={() => setExpandedIndex(expandedIndex === i ? null : i)}
            />
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg border border-gray-200 p-5 flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-lg"></i>
          </div>
          <div className="flex-1">
            <p className="font-bold text-[#1A365D] text-sm mb-1">Already have a passport to renew?</p>
            <p className="text-gray-500 text-sm leading-relaxed">
              Renewals can often be handled entirely by mail — no facility visit required. Start your order online, and we will confirm your eligibility and send your personalized checklist. Most Hammond clients never need to set foot in a post office.
            </p>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-1.5 bg-[#1A365D] hover:bg-[#0F2240] text-white font-bold text-xs px-5 py-2.5 rounded-md transition-all whitespace-nowrap flex-shrink-0">
            Start Renewal <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}